import axios from 'axios';

export async function buscarUbigeo(query) {
  const url = `/api/ubigeo?q=${encodeURIComponent(query)}`;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    return [];
  }
}

export async function obtenerUbigeoPorCodigo(codigo) {
  const url = `/api/ubigeo/${codigo}`;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    return null;
  }
}
